import NewsFeedIcon from '@repo/ui/components/Icon/NewsFeedIcon';
import ProfileIcon from '@repo/ui/components/Icon/ProfileIcon';
import SettingsIcon from '@repo/ui/components/Icon/SettingsIcon';
import StarIcon from '@repo/ui/components/Icon/StarIcon';

export const options = {
  Profile: {
    label: 'Profile & Projects',
    icon: ProfileIcon,
    url: '/user/dashboard',
  },
  AccountSettings: {
    label: 'Account Settings',
    teamLabel: 'Team Settings',
    icon: SettingsIcon,
    url: '/user/settings/account',
  },
  Subscription: {
    label: 'Subscription',
    icon: StarIcon,
    url: '/pricing',
  },
  Newsfeed: {
    label: 'Newsfeed',
    icon: NewsFeedIcon,
    url: '/feed',
  },
};

export const getActiveOption = (routerPath) => {
  return Object.keys(options).find((key) =>
    routerPath.toLowerCase().startsWith(options[key].url)
  );
};
